import {
  CREATE_RELEASE_NOTE,
  DELETE_RELEASE_NOTE,
  LIST_RELEASE_NOTE,
  RELEASE_NOTE_IS_READ,
  RELEASE_NOTE_ON_HOME,
  RELEASE_NOTE_UNREAD,
  RELEASE_SINGLE_DETAIL,
} from "../api";
import axiosInstance from "../axiosInstance";

export const creatReleaseNote = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_RELEASE_NOTE, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};

export const listReleaseNote = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_RELEASE_NOTE + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.sort) {
      BASE_URL += "sort_by=" + props.sort + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};

export const singleReleasedit = (props) => (onResponse) => {
  try {
    let BASE_URL = RELEASE_SINGLE_DETAIL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};

export const deleteReleaseNote = (props) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_RELEASE_NOTE, { data: { id: props?.id } })
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const releaseNoteOnHome = (props) => (onResponse) => {
  try {
    let BASE_URL = RELEASE_NOTE_ON_HOME + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};

export const releaseNoteIsReaded = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(RELEASE_NOTE_IS_READ, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};

export const releaseNoteUnreaded = (props) => (onResponse) => {
  try {
    let BASE_URL = RELEASE_NOTE_UNREAD + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};
